import module from 'viaticos/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class ViaticosConfiguracionProyectoColaboradoresColaboradorUsuarioComponent {
  colaborador
  idColaborador
  idProyecto
  onClose
  username
  vinculando = false

  constructor (ViaticosCatalgosUsuariosnovinculadosService, ViaticosColaboradorUsuarioService) {
    this.ViaticosCatalgosUsuariosnovinculadosService = ViaticosCatalgosUsuariosnovinculadosService
    this.ViaticosColaboradorUsuarioService = ViaticosColaboradorUsuarioService
  }

  $onInit () {
    this.promise = this.ViaticosCatalgosUsuariosnovinculadosService.get()
      .then(({data}) => (this.usuarios = orderBy(data, 'nombre')))
  }

  guardar () {
    this.vinculando = true
    this.ViaticosColaboradorUsuarioService.post(this.idProyecto, this.idColaborador, this.usuario)
      .then(({data}) => {
        this.username = data.username
        this.vinculando = false
      })
      .catch((error) => (console.log(error)))
  }

  cerrar () {
    this.onClose({$event: {detail: {username: this.username}}})
  }
}

module.component('viaticosConfiguracionProyectoColaboradoresColaboradorUsuario', {
  controller: ViaticosConfiguracionProyectoColaboradoresColaboradorUsuarioComponent,
  template,
  bindings: {
    idProyecto: '<',
    idColaborador: '<',
    colaborador: '<',
    username: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/viaticos/components/configuracion/proyecto/colaboradores/colaborador/usuario/component.js